// "Diagnose" under Einstellungen → System (W19 of APP-PARITY.md "Detail-Abgleich"; Dominik 19.10.2026: "Ja lass uns
// das Protokoll mal anzeigen für den Nutzer. Aber irgendwo versteckt, da es den meisten nichts hilft"): a card of its
// own on the page System (board "System": "Diagnose (i)" with its two buttons; the page itself is the hidden place),
// the machine's log and its last crash report fetched on a tap, shown as text. Owner and members (FR-24).
import { useState } from 'react';
import type { DiagResponse } from '@brewcore/app-contract';
import { diagView, reasonText } from '../../core/index.js';
import { Button, Card, CardHeader } from '../components/index.js';
import { useMachine } from '../machine-context.js';
import { useDeviceApi } from './use-device.js';

export function DiagnosisBox() {
  const { ctx, machineId } = useMachine();
  const api = useDeviceApi();
  const d = diagView(ctx);
  const [busy, setBusy] = useState<'log' | 'crash' | null>(null);
  const [doc, setDoc] = useState<DiagResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const load = async (kind: 'log' | 'crash') => {
    setBusy(kind);
    setError(null);
    const r = await api.diag(machineId, kind);
    setBusy(null);
    if (r.ok) setDoc(r.value);
    else setError(reasonText(ctx.lang, r.error.code));
  };
  const at = doc
    ? new Date(doc.at * 1000).toLocaleTimeString(ctx.lang === 'de' ? 'de-DE' : 'en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
    : '';
  return (
    <Card className="tab-card" data-testid="diag-card">
      <CardHeader title={d.title} info={{ text: d.hint, label: ctx.tr('infoShow'), testId: 'diag-info' }} />
      <div className="stack" data-testid="diag">
        <div className="btn-row">
          <Button
            variant="secondary"
            size="sm"
            busy={busy === 'log'}
            disabled={!d.enabled || busy !== null}
            onClick={() => void load('log')}
            data-testid="diag-log"
          >
            {d.log}
          </Button>
          <Button
            variant="secondary"
            size="sm"
            busy={busy === 'crash'}
            disabled={!d.enabled || busy !== null}
            onClick={() => void load('crash')}
            data-testid="diag-crash"
          >
            {d.crash}
          </Button>
        </div>
        {error && (
          <p className="field-error" role="alert" data-testid="diag-error">
            {error}
          </p>
        )}
        {doc && (
          <>
            <p className="hint" data-testid="diag-at">
              {ctx.tr(doc.kind === 'log' ? 'diagKindLog' : 'diagKindCrash')} · {ctx.tr('diagAt', { t: at })}
            </p>
            {/* the machine's text as text (React text node), never as HTML */}
            <pre className="diag-text" data-testid="diag-text">
              {doc.text.trim() ? doc.text : ctx.tr('diagEmpty')}
            </pre>
          </>
        )}
      </div>
    </Card>
  );
}
